import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RRIFilter } from '../../../common/interfaces/filters/filter.interface';
import { RRIInput } from '../../../form-inputs/interfaces/input-settings.interface';
import { RRIInputOption } from '../../../form-inputs/interfaces/input-option.interface';
import { RRIFilterOption } from '../../../common/interfaces/filters/filter-options.interface';
import { RRIFilterOutput } from '../../../common/interfaces/filters/filter-output.interface';
import { RR_FILTER_TYPE } from '../../../common/enum/filters/filter-type.enum';

@Component({
  selector: 'rr-radio-select-filter',
  templateUrl: './radio-select-filter.component.html',
  styleUrls: ['./radio-select-filter.component.scss'],
})
export class RadioSelectFilterComponent<T> implements OnInit {
  @Input() model: RRIFilter<RRIFilterOption<T>, T>;
  @Input() options: RRIFilterOption<T>[];
  @Input() formComponentSettings: RRIInput<RRIInputOption<T>>;
  @Output() changedFilter: EventEmitter<RRIFilterOutput<RRIFilterOption<T>>> =
    new EventEmitter();

  public radiobuttonFieldSettings: RRIInput<RRIInputOption<T>>;

  constructor() {
    this.setRadioButtonSettings();
  }

  ngOnInit(): void {
    this.setRadioButtonSettings();
  }

  public onRadiobuttonFieldChange(selectedItem: RRIFilterOption<T>): void {
    this.changedFilter.emit({
      type: RR_FILTER_TYPE.RADIO_SELECT,
      filterBy: {
        ...this.model.filterBy,
        value: selectedItem,
      },
    });
  }

  private setRadioButtonSettings(): void {
    if (!this.formComponentSettings) {
      this.radiobuttonFieldSettings = {
        fieldName: 'radio-filter',
        label: '',
      };
      if (!this.model) {
        return;
      }
      this.radiobuttonFieldSettings.label = this.model.settings?.title ?? '';
      this.radiobuttonFieldSettings.placeholder =
        this.model.settings?.title ?? '';
      return;
    }
    this.radiobuttonFieldSettings = this.formComponentSettings;
  }
}
